import React from 'react';
import { Card } from '../../components/ui/Card';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AlertTriangle, TrendingUp, Clock, CheckCircle } from 'lucide-react';
const ORDER_TABS = [{
  label: 'Live Queue',
  path: ''
}, {
  label: 'Flagged (3)',
  path: 'flagged'
}, {
  label: 'Order History',
  path: 'history'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const HOURLY_DATA = [{
  hour: '10',
  orders: 12
}, {
  hour: '11',
  orders: 25
}, {
  hour: '12',
  orders: 45
}, {
  hour: '13',
  orders: 55
}, {
  hour: '14',
  orders: 48
}, {
  hour: '15',
  orders: 35
}, {
  hour: '16',
  orders: 28
}, {
  hour: '17',
  orders: 42
}, {
  hour: '18',
  orders: 58
}, {
  hour: '19',
  orders: 65
}, {
  hour: '20',
  orders: 52
}, {
  hour: '21',
  orders: 38
}, {
  hour: '22',
  orders: 25
}, {
  hour: '23',
  orders: 15
}];
export function Analytics() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2446">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-2447">Order Analytics</h1>
      <TabNavigation tabs={ORDER_TABS} basePath="/orders" data-id="element-2448" />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-2449">
        <Card className="p-4" data-id="element-2450">
          <div className="text-sm text-text-secondary mb-1" data-id="element-2451">Total Orders</div>
          <div className="text-2xl font-bold mb-1" data-id="element-2452">847</div>
          <div className="text-xs text-accent-success" data-id="element-2453">+12% vs LW</div>
        </Card>
        <Card className="p-4" data-id="element-2454">
          <div className="text-sm text-text-secondary mb-1" data-id="element-2455">Avg Prep Time</div>
          <div className="text-2xl font-bold mb-1" data-id="element-2456">11.2 min</div>
          <div className="text-xs text-accent-success" data-id="element-2457">-1.5 min ✓</div>
        </Card>
        <Card className="p-4" data-id="element-2458">
          <div className="text-sm text-text-secondary mb-1" data-id="element-2459">On-Time Rate</div>
          <div className="text-2xl font-bold mb-1" data-id="element-2460">89%</div>
          <div className="text-xs text-accent-success" data-id="element-2461">+3% vs LW</div>
        </Card>
        <Card className="p-4" data-id="element-2462">
          <div className="text-sm text-text-secondary mb-1" data-id="element-2463">Avg Rating</div>
          <div className="text-2xl font-bold mb-1" data-id="element-2464">9.3 ⭐</div>
          <div className="text-xs text-accent-success" data-id="element-2465">+0.2 vs LW</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2466">
        {/* Hourly Chart */}
        <Card className="p-6" data-id="element-2467">
          <h3 className="font-bold mb-4" data-id="element-2468">Orders by Hour</h3>
          <div className="h-64 w-full" data-id="element-2469">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2470">
              <BarChart data={HOURLY_DATA} data-id="element-2471">
                <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" vertical={false} data-id="element-2472" />
                <XAxis dataKey="hour" stroke="#6B7280" fontSize={12} tickLine={false} axisLine={false} data-id="element-2473" />
                <Tooltip contentStyle={{
                backgroundColor: '#1A1F2E',
                borderColor: '#ffffff10',
                borderRadius: '8px'
              }} cursor={{
                fill: '#ffffff05'
              }} data-id="element-2474" />
                <Bar dataKey="orders" fill="#8B5CF6" radius={[4, 4, 0, 0]} data-id="element-2475" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>

        {/* AI Accuracy */}
        <Card className="p-6" data-id="element-2476">
          <div className="flex items-center gap-2 mb-4" data-id="element-2477">
            <span className="text-xl" data-id="element-2478">🤖</span>
            <h3 className="font-bold" data-id="element-2479">AI Estimation Accuracy</h3>
          </div>

          <div className="flex justify-between mb-6 p-3 bg-white/5 rounded-lg" data-id="element-2480">
            <div data-id="element-2481">
              <div className="text-xs text-text-secondary uppercase" data-id="element-2482">
                Overall Accuracy
              </div>
              <div className="text-xl font-bold" data-id="element-2483">87%</div>
            </div>
            <div className="text-right" data-id="element-2484">
              <div className="text-xs text-text-secondary uppercase" data-id="element-2485">
                Avg Error
              </div>
              <div className="text-xl font-bold" data-id="element-2486">±2.3 min</div>
            </div>
          </div>

          <div className="space-y-4" data-id="element-2487">
            <div data-id="element-2488">
              <div className="flex justify-between text-sm mb-1" data-id="element-2489">
                <span data-id="element-2490">🍔 Burgeri</span>
                <span className="text-text-secondary" data-id="element-2491">±1.8 min</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-2492">
                <div className="h-full bg-accent-primary w-[89%]" data-id="element-2493"></div>
              </div>
            </div>
            <div data-id="element-2494">
              <div className="flex justify-between text-sm mb-1" data-id="element-2495">
                <span data-id="element-2496">🥞 Palačinke</span>
                <span className="text-text-secondary" data-id="element-2497">±1.2 min</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-2498">
                <div className="h-full bg-accent-success w-[92%]" data-id="element-2499"></div>
              </div>
            </div>
            <div data-id="element-2500">
              <div className="flex justify-between text-sm mb-1" data-id="element-2501">
                <span data-id="element-2502">🌯 Giros</span>
                <span className="text-accent-warning flex items-center gap-1" data-id="element-2503">
                  ±3.5 min <AlertTriangle size={12} data-id="element-2504" />
                </span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-2505">
                <div className="h-full bg-accent-warning w-[78%]" data-id="element-2506"></div>
              </div>
            </div>
          </div>
        </Card>

        {/* Channel Breakdown */}
        <Card className="p-6" data-id="element-2507">
          <h3 className="font-bold mb-4" data-id="element-2508">Channel Breakdown</h3>
          <div className="space-y-4" data-id="element-2509">
            <div data-id="element-2510">
              <div className="flex justify-between mb-1" data-id="element-2511">
                <span className="font-medium text-blue-400" data-id="element-2512">Wolt</span>
                <span className="text-text-secondary" data-id="element-2513">782 (92.3%)</span>
              </div>
              <div className="h-3 bg-white/10 rounded-full overflow-hidden" data-id="element-2514">
                <div className="h-full bg-blue-400 w-[92.3%]" data-id="element-2515"></div>
              </div>
            </div>
            <div data-id="element-2516">
              <div className="flex justify-between mb-1" data-id="element-2517">
                <span className="font-medium text-green-400" data-id="element-2518">Collina.rs</span>
                <span className="text-text-secondary" data-id="element-2519">65 (7.7%)</span>
              </div>
              <div className="h-3 bg-white/10 rounded-full overflow-hidden" data-id="element-2520">
                <div className="h-full bg-green-400 w-[7.7%]" data-id="element-2521"></div>
              </div>
            </div>
          </div>
        </Card>

        {/* Flagged Summary */}
        <Card className="p-6" data-id="element-2522">
          <div className="flex items-center gap-2 mb-4" data-id="element-2523">
            <span className="text-xl" data-id="element-2524">🚩</span>
            <h3 className="font-bold" data-id="element-2525">Flagged Orders Summary</h3>
          </div>

          <div className="mb-4" data-id="element-2526">
            <div className="text-sm mb-1" data-id="element-2527">
              This Week:{' '}
              <span className="font-bold text-white" data-id="element-2528">15 flagged</span> (1.8%)
            </div>
            <div className="text-xs text-accent-success" data-id="element-2529">
              vs Last Week: 18 (2.1%) ✓
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-2530">
            <div data-id="element-2531">
              <div className="text-xs text-text-secondary uppercase mb-2" data-id="element-2532">
                By Issue
              </div>
              <div className="space-y-1" data-id="element-2533">
                <div className="flex justify-between" data-id="element-2534">
                  <span data-id="element-2535">Low rating</span> <span data-id="element-2536">6</span>
                </div>
                <div className="flex justify-between" data-id="element-2537">
                  <span data-id="element-2538">Negative comment</span> <span data-id="element-2539">5</span>
                </div>
                <div className="flex justify-between" data-id="element-2540">
                  <span data-id="element-2541">Very late</span> <span data-id="element-2542">3</span>
                </div>
              </div>
            </div>
            <div data-id="element-2543">
              <div className="text-xs text-text-secondary uppercase mb-2" data-id="element-2544">
                By Location
              </div>
              <div className="space-y-1" data-id="element-2545">
                <div className="flex justify-between" data-id="element-2546">
                  <span data-id="element-2547">Vračar</span> <span data-id="element-2548">5</span>
                </div>
                <div className="flex justify-between" data-id="element-2549">
                  <span data-id="element-2550">Banovo Brdo</span> <span data-id="element-2551">4</span>
                </div>
                <div className="flex justify-between" data-id="element-2552">
                  <span data-id="element-2553">Novi Beograd</span> <span data-id="element-2554">4</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}